import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Select } from 'antd'

const TRUCK_ORIGIN_ADDRESSES_QUERY = gql`
    query TruckOriginAddresses($query: String) {
        truckOriginAddresses(query: $query, first: 10) {
            nodes {
                id
                name
                detail
            }
        }
    }
`

const renderOptions = options => options.map(({ id, name }) => {
    return <Select.Option key={id} value={id}>{name}</Select.Option>
})

const TruckOriginAddressSelector = ({ onChange = () => {}, onChangeEvent = () => {}, ...restProps }) => {
    const [query, setQuery] = useState('')
    const { loading, data, error } = useQuery(TRUCK_ORIGIN_ADDRESSES_QUERY, {
        variables: { query }
    })

    if (error) console.error(error)

    const options = (data && data.truckOriginAddresses && data.truckOriginAddresses.nodes) || []

    const handleChange = (value) => {
        onChange(value)
        onChangeEvent(options.find(option => option.id === value))
    }

    const handleSearch = value => {
        setQuery(value)
    }

    return (
        <Select
            allowClear
            loading={loading}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            showSearch
            {...restProps}
        >
            {renderOptions(options)}
        </Select>
    )
}

TruckOriginAddressSelector.propTypes = {
    onChange: PropTypes.func,
    onChangeEvent: PropTypes.func
}

export default TruckOriginAddressSelector
